import { action } from 'typesafe-actions';

import * as types from './types';
import { ResearchersRequestParams } from '@interfaces/researchers-request-params';
import ResearcherTab from '@interfaces/researchers-tab';

export const fetchResearchersPage = (params: ResearchersRequestParams = {}) =>
    action(types.FETCH_RESEARCHERS_PAGE, params);
export const fetchResearchersPageSuccess = (data: any) =>
    action(types.FETCH_RESEARCHERS_PAGE_SUCCESS, data);
export const fetchResearchersPageError = (error: any) =>
    action(types.FETCH_RESEARCHERS_PAGE_ERROR, error);

export const fetchResearcher = (id: number) => action(types.FETCH_RESEARCHER, { id });
export const fetchResearcherSuccess = (data: any) => action(types.FETCH_RESEARCHER_SUCCESS, data);
export const fetchResearcherError = (error: any) => action(types.FETCH_RESEARCHER_ERROR, error);

export const setSelectedThemeSlug = (themeSlug?: string) => action(types.SET_SELECTED_THEME_SLUG, themeSlug);
export const setSelectedTabIndex = (index: number) => action(types.SET_SELECTED_TAB_INDEX, index);
export const setResearcherTabs = (tabs: ResearcherTab[]) => action(types.SET_RESEARCHER_TABS, tabs);
